var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#4d170a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.53C0 49.7 17.7 32 39.53 32H472.5C494.3 32 512 49.7 512 71.53C512 80.73 508.8 89.64 502.9 96.73L320 317.8V446.1C320 464.8 304.8 480 286.1 480C278.6 480 271.3 477.5 265.3 472.9L204.4 425.4C196.6 419.4 192 410.1 192 400.2V317.8L9.076 96.73C3.21 89.64 0 80.73 0 71.53V71.53zM39.53 64C35.37 64 32 67.37 32 71.53C32 73.28 32.61 74.98 33.73 76.33L220.3 301.8C222.7 304.7 224 308.3 224 312V400.2L284.1 447.6C285.3 447.9 285.7 448 286.1 448C287.2 448 288 447.2 288 446.1V312C288 308.3 289.3 304.7 291.7 301.8L478.3 76.33C479.4 74.98 480 73.28 480 71.53C480 67.37 476.6 64 472.5 64H39.53z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.6df6a6f1a2b5942e2261544ee0b4039a.svg";
export { ForwardRef as ReactComponent };